import React from 'react';

import './contentTable.scss'

import Select from 'react-select'

const ContentTable = (props) => {
    const options = [
        { value: 'hr', label: 'Create Position > Position Request > Staff New Project' },
        { value: 'it', label: 'Create New Position' },
        { value: 'code', label: 'Create Replacement Position' }
    ]
    const supervisoryOrganization = props.supervisoryOrganization ? props.supervisoryOrganization.label : '(empty)'

    return (
        <div className='contentTable'>
            <table>
                <tbody>
                    <tr className='formItem'>
                        <td className='label' id='createPosition-supervisoryOrganization-label'>Supervisory Organization</td>
                        <td className='req'></td>
                        <td className='item' aria-labelledby='createPosition-supervisoryOrganization-label'>{supervisoryOrganization}</td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createPosition-positionRequestReason'>Position Request Reason</label></td>
                        <td className='req'></td>
                        <td className='item'>
                            <Select className='select' inputId='createPosition-positionRequestReason' name='positionRequestReason' options={options} maxMenuHeight={120}/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createPosition-jobPostingTitle'>Job Posting Title</label></td>
                        <td className='req' aria-hidden='true'>*</td>
                        <td className='item'>
                            <input className='input' type='text' id='createPosition-jobPostingTitle' name='jobPostingTitle' required aria-required='true'/>
                        </td>
                    </tr>

                    <tr className='formItem'>
                        <td className='label'><label htmlFor='createPosition-numberOfPositions'>Number of Positions</label></td>
                        <td className='req' aria-hidden='true'>*</td>
                        <td className='item'>
                            <input className='input' type='number' id='createPosition-numberOfPositions' name='numberOfPositions' min='1' required aria-required='true'/>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ContentTable;
